import React from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
//import logo from "assets/img/logoblanco.jpg";
import logo from "assets/img/logothvertical.png"


function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const [imageLogo, setImage] = React.useState(logo);

  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        style={{
          backgroundImage: "url(" + image + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a href="#" className="simple-text logo-mini mx-1">
            <div>
              <img
                src={imageLogo}
                alt="..."
                width="220px" 
                height="100px"
               
              />
            </div>
          </a>
          <a className="simple-text" href="https://corporaciontesihuneeus.cl/">
            
          </a>
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if (!prop.redirect && prop.ismenu)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className={({isActive}) => 'nav-link' + (isActive ?' active' : '')}
                                        
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
